import React from "react";
import { useTranslation } from "pro-features/components/WithTranslation/src/I18n";
import { createExportTableRenderer } from "app/pages/sales-intelligence/common-components/export-table/exportTableRenderer";
import type { ExportName } from "app/pages/sales-intelligence/sub-modules/management/store/type";
import { getIntegrationNameFromUrl } from "app/pages/sales-intelligence/common-components/export-table/getIntegrationNameFromUrl";

export const useExportTableService = (exportName: ExportName) => {
    const translate = useTranslation();
    const { integrationName } = getIntegrationNameFromUrl();

    return React.useMemo(
        () => createExportTableRenderer(translate, integrationName, exportName),
        [integrationName, exportName],
    );
};
